module.exports = __webpack_public_path__ + "img/login-image.c8ad0cc5.png";